<template>
  <div>
    <v-page-toolbar :title="$t('_menu.news')" icon="campaign">
      <template v-slot:buttons>
        <v-spacer></v-spacer>

        <v-btn color="success" dark class="mb-2" @click="dialog = true">
          <v-icon dark left>add_circle_outline</v-icon>
          {{ $t("common.new").toLocaleUpperCase(lang) }}
          {{ $t("_news.news").toLocaleUpperCase(lang) }}
        </v-btn>
        <new-news-button
          :dialog.sync="dialog"
          :editedItem="newItem"
          :editedIndex="itemIndex"
          @confirmed="onConfirmed"
          @cancelled="onCancelled"
        />
      </template>
    </v-page-toolbar>

    <v-layout row wrap fluid>
      <v-flex lg12>
        <news-table
          :filter.sync="filter"
          :newsItems="filterNews"
          :groupId="routeId"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import NewsTable from "./NewsTable";
import NewNewsButton from "./NewNewsButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { NewsTable, NewNewsButton },

  created() {
    // this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
  },
  data() {
    return {
      routeId: "7166c32d-b6f9-4a97-85c4-0124acb2713b",
      routeName: "",
      filter: {},
      // emptyFilter: {
      //   name: "",
      //   cityCode: null,
      //   countyCode: null,
      //   categoryIds: [],
      // },
      newItem: {
        title: "",
        text: "",
        date: "",
        time: "",
      },
      dialog: false,
      itemIndex: -1,
      page: 0,
      totalItemsPerPage: 10000,
      places: null,
      center: [36.33534518345682, 41.295020754851635],
      zoom: 9,
      showDialog: false,
      placeCoord: [],
      selectedItem: null,
    };
  },
  computed: {
    ...mapGetters({ news: "news/items" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },

    filterNews() {
      return this.news.map((item) =>
        Object.assign({}, item, {
         
          dateTable: new Date(item.date).toLocaleDateString(this.lang) +
            " " +
            new Date(item.date).toLocaleTimeString(this.lang),
        })
      );
    },
  },
  methods: {
    ...mapActions(["news/getItems"]),

    async refreshTable() {
      console.log("after confirm");
      // let filterr = JSON.parse(JSON.stringify(this.filter));
      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("news/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        // filter: filterr,
      });
    },
    onConfirmed(editedItem) {
      // hide a dialog
      console.log("confffffffffffffirmeddddd");
      this.dialog = false;
      this.refreshTable();
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
  },
};
</script>
